module.exports = __webpack_public_path__ + "img/loading.ce66c43f.gif";